import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';


/**
* @desc reducer for logged-in user profile
* @version
* @author Lakshmikanth 
* @return updated state
*/
const initialState = {
  clientDetails: {},
  userImageSignedUrl: null,
  interviewListCount:0,
  uploadButtonStatus: false,
  pageDataLoss: false,
  nextPath: ''
};

const setClient = ( state = initialState , action ) => {
  const clientDetails = {...action.clientDetails};
  return updateObject( state, { clientDetails : clientDetails } );
};

const clearReduxState = ( state = initialState , action ) => {
  return updateObject( state, initialState );   
};

const updateProfileImage = (state = initialState, action) => {
  const clientDetails = {...state.clientDetails};
  clientDetails.user_image_url = action.userImageUrl;
  return updateObject( state, { clientDetails : clientDetails, userImageSignedUrl: action.UserImageSignedUrl });  
}

const setInterViewListCount = ( state = initialState , action ) => {
  return updateObject( state, { interviewListCount : action.count }  );   
};

const setUploadButton = (state = initialState , action) => {
  return updateObject( state, { uploadButtonStatus: action.status});
}
const setPageLossData = (state = initialState , action ) => {
  return updateObject( state, { pageDataLoss : action.pageData, nextPath: action.nextPath }  );   
}


const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SET_CLIENT_DETAILS: 
      return setClient(state, action);
    case actionTypes.COGNITO_LOGOUT:
      return clearReduxState(state,action);  
    case actionTypes.UPDATE_PROFILE_IMAGE:
      return updateProfileImage(state, action);
    case actionTypes.SET_INTERVIEWLIST_COUNT:
      return setInterViewListCount(state, action);
    case actionTypes.SET_UPLOAD_BUTTON:
      return setUploadButton(state, action);       
    case actionTypes.SET_PAGEDATA_LOSS:
      return setPageLossData(state, action);
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/clientProfile.js